import moment from "moment-timezone";

import type { SectionSpecItem } from "@/shared/models/SectionSpec";
import type { InspectionWithValues } from "../models/Inspection";
import type { InspectionFormValues } from "../models/InspectionForm";
import {
	formatMeasurement,
	formatStoredMeasurement,
} from "@/shared/utils/measurementPrecision";
import { currentSampleMinute } from "./sampleTime";
export const REQUIRED_SAMPLE_AT_MESSAGE = "A valid Sample At time is required";
export const REQUIRED_SECTION_MESSAGE = "Section is required";
export const REQUIRED_DIMENSION_MESSAGE =
	"At least one dimension reading is required";

export const parse = (raw: string): number | null => {
	const t = raw.trim();
	if (t === "") return null;
	const n = Number(t);
	return Number.isFinite(n) ? n : null;
};

export const statusColor = (s: string) =>
	s === "Over" || s === "Under" ? "error.main" : "text.primary";

export const formatTolerance = (value: number | null) =>
	value === null ? "-" : formatMeasurement(value);

export const isDimensionEditable = (
	dimension: SectionSpecItem,
	isEditingInspection: boolean,
) => dimension.Applies && (isEditingInspection || dimension.IsActive);

export const readingKey = (profileItemId: number) => `item${profileItemId}`;

export const getItemKeysKey = (itemKeys: string[]) =>
	JSON.stringify(itemKeys.toSorted());

export const getFormValues = (
	editing: InspectionWithValues | null,
	sectionId: number | null,
	serverTimeZone: string,
	itemKeys: string[],
): InspectionFormValues => ({
	inspectedAt: editing
		? moment(editing.InspectedAt)
		: moment(currentSampleMinute()).tz(serverTimeZone),
	sectionId: editing?.SectionId ?? sectionId,
	heatId: editing?.HeatId ?? null,
	weight: formatStoredMeasurement(editing?.MeasuredLbsPerFoot),
	comments: editing?.Comments ?? "",
	readings: {
		...Object.fromEntries(itemKeys.map((key) => [key, ""])),
		...(editing
			? Object.fromEntries(
					Object.values(editing.values)
						.filter((value) => value.NumericValue !== null)
						.map((value) => [
							readingKey(value.ProfileItemId),
							formatStoredMeasurement(value.NumericValue),
						]),
				)
			: {}),
	},
});
